<div class="container-fluid h-100 container-404">
  <div class="row h-100">
    <div class="col section-content">
      <div class="container-404-info">
        <button type="button" class="btn button-back-404" (click)="back()">
          <i class="bi bi-arrow-left"></i>
          Go Back
        </button>
        <h2>404 error</h2>
        <h1>Page Not Found</h1>
        <h3>Sorry, the page you are looking for doesn't exist</h3>
      </div>
    </div>
    <div class="col section-right-404">
    </div>
  </div>
</div>
